import {css} from 'styled-components';

import type {StyledProps} from './types';

const base = css<StyledProps>``;

export const web = css<StyledProps>`
  display: flex;
  box-sizing: border-box;
  ${base}
`;

export const native = css<StyledProps>`
  flex-direction: row;
  ${base}
`;
